import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  .swiper-initialized {\n    overflow: visible;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "styled-components";
export var StoryArticleContainer = styled.div.withConfig({
    componentId: "sc-6ae90f44-0"
})(_templateObject());
